import { render, staticRenderFns } from "./OrderLastInfo.vue?vue&type=template&id=19850604&"
import script from "./OrderLastInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderLastInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports